import React from 'react';

import { styled } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

const ContentContainer = styled('div')({
  minWidth: '300px',
  flex: 1,
});

const SdmDrawer = ({ children, isDrawerOpen, toggleDrawer }) => {
  const handleDrawerToggle = (event) => {
    if (
      (event && event.type === 'keydown' && event.key === 'Tab') ||
      !event.target.className?.includes ||
      !event.target.className.includes('MuiBackdrop-root')
    ) {
      return;
    }
    toggleDrawer();
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={isDrawerOpen}
      onClose={toggleDrawer}
      onOpen={toggleDrawer}
      style={{ display: 'flex' }}
    >
      <ContentContainer
        role="presentation"
        onClick={handleDrawerToggle}
        onKeyDown={handleDrawerToggle}
      >
        {children}
      </ContentContainer>
    </SwipeableDrawer>
  );
};

export { SdmDrawer };
